import isChatIframed from '../chat/isChatIframed';

const useDetectIframe = () => isChatIframed();

export default useDetectIframe;
